module.exports = __webpack_public_path__ + "image/guide_tire_img1.png";